import React, { useState } from "react";
import axios from "axios";
import ProfileAvatarEditor from "./ProfileAvatarEditor";
import { getToken } from "../../auth/token";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export default function ProfileSettings({ user, onUpdated }) {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [passwordSuccess, setPasswordSuccess] = useState("");
    const [savingPassword, setSavingPassword] = useState(false);

    const handlePasswordSubmit = async (event) => {
        event.preventDefault();
        setPasswordError("");
        setPasswordSuccess("");

        if (!currentPassword) {
            setPasswordError("Укажите текущий пароль");
            return;
        }
        if (newPassword.length < 8) {
            setPasswordError("Новый пароль должен быть не короче 8 символов");
            return;
        }
        if (newPassword !== confirmPassword) {
            setPasswordError("Пароли не совпадают");
            return;
        }

        setSavingPassword(true);
        const token = getToken();
        try {
            await axios.patch(
                `${API_BASE_URL}/api/me/password`,
                { currentPassword, newPassword },
                {
                    headers: token ? { Authorization: `Bearer ${token}` } : {},
                    withCredentials: true,
                },
            );
            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");
            setPasswordSuccess("Пароль успешно изменён");
        } catch (error) {
            const message = error?.response?.data?.error || "Не удалось сменить пароль";
            setPasswordError(message);
        } finally {
            setSavingPassword(false);
        }
    };

    return (
        <div className="profile-dashboard__grid profile-settings__grid">
            <section className="profile-settings__photo-block" aria-labelledby="profile-settings-photo-title">
                <h2 id="profile-settings-photo-title" className="profile-settings__photo-title">Фото профиля</h2>
                <ProfileAvatarEditor user={user} onUpdated={onUpdated} />
            </section>

            <section aria-labelledby="profile-settings-password-title">
                <h2 id="profile-settings-password-title" className="profile-settings__photo-title">Смена пароля</h2>
                <form className="profile-settings__form" onSubmit={handlePasswordSubmit}>
                    <label>
                        Текущий пароль
                        <input
                            type="password"
                            className="form-control"
                            value={currentPassword}
                            onChange={(event) => setCurrentPassword(event.target.value)}
                            autoComplete="current-password"
                            required
                        />
                    </label>
                    <label>
                        Новый пароль
                        <input
                            type="password"
                            className="form-control"
                            value={newPassword}
                            onChange={(event) => setNewPassword(event.target.value)}
                            autoComplete="new-password"
                            minLength={8}
                            required
                        />
                    </label>
                    <label>
                        Повторите новый пароль
                        <input
                            type="password"
                            className="form-control"
                            value={confirmPassword}
                            onChange={(event) => setConfirmPassword(event.target.value)}
                            autoComplete="new-password"
                            minLength={8}
                            required
                        />
                    </label>
                    {passwordError && <p className="form-error">{passwordError}</p>}
                    {passwordSuccess && <p className="form-success">{passwordSuccess}</p>}
                    <button type="submit" className="toolbar-btn" disabled={savingPassword}>
                        {savingPassword ? "Сохранение…" : "Сменить пароль"}
                    </button>
                </form>
            </section>
        </div>
    );
}
